// ---------------------------------------------
// ======---------------------------------======
//  Site JS
// ======---------------------------------======
// ---------------------------------------------

//===-----------------===
// Reusable functions
//===-----------------===
const classToggle = function (elements, elementClass) {
	elements.forEach((element) => {
		if (!element.classList.contains(`${elementClass}`)) {
			element.classList.add(`${elementClass}`);
		} else {
			element.classList.remove(`${elementClass}`);
		}
	});
};

const alertStatus = function (alert, alertMessage) {
	document.querySelector(alert).innerHTML = `<p>${alertMessage}</p>`;
};

//===-----------------===
// Mobile menu
//===-----------------===
const navigation = document.querySelector('.site-nav');
// Checking for the navigation
if (navigation) {
	const navBtn = document.querySelector('.site-nav__btn');

	navBtn.addEventListener('click', function () {
		// Toggling the classes for the menu, overlay, and body
		classToggle([navigation], 'js-menu-open');
		// Setting an alert status for the menu, overlay, and body
		if (navigation.classList.contains('js-menu-open')) {
			alertStatus('#nav-status', 'Menu opened');
		} else {
			alertStatus('#nav-status', 'Menu closed');
		}
		// Checking to see if the menu is openened or closed to change the buttons text and aria-expanded values
		if (navigation.classList.contains('js-menu-open')) {
			navBtn.querySelector('#site-nav__txt').innerHTML = 'Close';
			navBtn.setAttribute('aria-expanded', true);
		} else {
			navBtn.querySelector('#site-nav__txt').innerHTML = 'Menu';
			navBtn.setAttribute('aria-expanded', false);
		}
	});
}

//===-----------------===
// Video player
//===-----------------===
const video = document.querySelector('#skai-video');

if (video) {
	const watchBtn = video.parentNode.querySelector('.video-controls');
	const options = {};
	const player = new Vimeo.Player(video, options);

	watchBtn.classList.add('js-video-looping');
	watchBtn.addEventListener('click', function (e) {
		e.stopImmediatePropagation();
		if (watchBtn.classList.contains('js-video-looping')) {
			classToggle([watchBtn], 'js-video-playing');
			//unmuting the video
			player.setVolume(1);
			// starting the video over at the beginning (its looping and muted to start)
			player.setCurrentTime(0);
			player.play();
		}
	});
	video.parentNode.addEventListener('click', function (e) {
		e.stopImmediatePropagation();
		if (!watchBtn.classList.contains('js-video-playing')) {
			player.play();
			classToggle([watchBtn], 'js-video-playing');
			watchBtn.innerHTML = 'Pause';
		} else {
			player.pause();
			watchBtn.classList.remove('js-video-playing');
		}
	});
}

//===-----------------===
// Accordions
//===-----------------===
const accordions = document.querySelectorAll('.accordion');

if (accordions) {
	accordions.forEach((accordion) => {
		const accordionHeader = accordion.querySelector('.accordion-header');
		accordionHeader.addEventListener('click', function () {
			const accordionText = accordionHeader.innerText;
			const isActive = accordion.classList.contains('js-accordion-active');

			accordions.forEach((element) => {
				element.classList.remove('js-accordion-active');
				element.setAttribute('aria-expanded', false);
				alertStatus('#accordion-status', `${accordionText} accordion is closed`);
			});
			if (!isActive) {
				accordion.classList.add('js-accordion-active');
				accordion.setAttribute('aria-expanded', true);
				alertStatus('#accordion-status', `${accordionText} accordion is open`);
			}
		});
	});
}

function moveElementToTopWithOffset(elementClass, offset) {
	const element = document.querySelector(elementClass);
	if (element) {
		window.scrollTo({
			top: element.getBoundingClientRect().top + window.scrollY - offset,
			behavior: 'smooth'
		});
	}
}

//===-----------------===
// Sticky desktop nav
//===-----------------===
if (typeof document.querySelector('.site-header') !== 'undefined') {
	let lastScrollTopNav = 0;
	const body = document.querySelector('body');
	const siteHeader = document.querySelector('.site-header');

	function setHeaderHeight() {
		const headerHeight = siteHeader.getBoundingClientRect().height;
		body.style.setProperty('--js-header-height', `${headerHeight}px`);
	}
	setHeaderHeight();

	setTimeout(() => {
		window.addEventListener(
			'scroll',
			function () {
				const st = window.scrollY || document.documentElement.scrollTop;
				const headerHeight = siteHeader.getBoundingClientRect().height;
				setHeaderHeight();

				if (st <= headerHeight) {
					body.classList.remove('sticky-header');
					body.removeAttribute('data-sticky');
				} else if (lastScrollTopNav <= headerHeight) {
					if (
						body.getAttribute('data-sticky') === 'header' &&
						body.getAttribute('data-menu-status') != 'open'
					) {
						body.setAttribute('data-sticky', 'header-out');

						setTimeout(() => {
							body.removeAttribute('data-sticky');
							body.classList.remove('sticky-header');
							console.log('this is the timeout');
						}, 300);
					}
				} else {
					if (body.getAttribute('data-sticky') !== 'header') {
						body.classList.add('sticky-header');
						body.setAttribute('data-sticky', 'header-in');

						setTimeout(() => {
							if (lastScrollTopNav <= headerHeight) {
								body.removeAttribute('data-sticky');
								body.classList.add('sticky-header');
							} else {
								body.setAttribute('data-sticky', 'header');
							}
						}, 300);
					}
				}

				if (location.href.includes('/insights/articles/')) {
					document.querySelector('body').classList.add('sticky-header');
				}

				lastScrollTopNav = st <= 0 ? 0 : st;
			},
			false
		);
	}, 50);
}
